"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LineManagers = function LineManagers(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.0351 12.0753C20.0351 13.8929 18.7083 15.2455 17.2295 15.2455C15.7499 15.2455 14.4238 13.8988 14.4238 12.0753V11.4208C14.4238 9.60313 15.7507 8.25049 17.2295 8.25049C18.7083 8.25049 20.0351 9.60313 20.0351 11.4208V12.0753Z",
    stroke: "#7F0442",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.0945 17.6969L13.0957 17.6965C15.7533 16.9599 18.7126 16.9599 21.3702 17.6963C22.3354 17.9657 23.004 18.8477 23.004 19.8306V20.9729H11.4688V19.8306C11.4688 18.8443 12.1405 17.9596 13.0945 17.6969Z",
    stroke: "#7F0442",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.4521 15.9955C17.4124 15.9955 19.0078 14.2365 19.0078 12.0753V11.4208C19.0078 9.25949 17.4124 7.50049 15.4521 7.50049C13.4919 7.50049 11.8965 9.25949 11.8965 11.4208V12.0753C11.8965 14.2434 13.4919 15.9955 15.4521 15.9955Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.4521 19.5512C17.4124 19.5512 19.0078 17.7922 19.0078 15.6309V14.9764C19.0078 12.8152 17.4124 11.0562 15.4521 11.0562C13.4919 11.0562 11.8965 12.8152 11.8965 14.9764V15.6309C11.8965 17.799 13.4919 19.5512 15.4521 19.5512Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.6825 17.8624C17.8936 17.0895 14.7956 17.0895 12.0068 17.8624C10.7267 18.2149 9.83008 19.396 9.83008 20.7193V22.6115H22.8654V20.7193C22.8654 19.396 21.9687 18.2211 20.6825 17.8624Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.1297 15.1954C13.1966 14.4225 11.0492 14.4225 9.11617 15.1954C8.22893 15.5479 7.60742 16.729 7.60742 18.0523V19.9445H16.6427V18.0523C16.6427 16.729 16.0212 15.5541 15.1297 15.1954Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.42853 19.4742L9.42973 19.4739C12.0873 18.7373 15.0466 18.7372 17.7042 19.4737C18.6693 19.7431 19.338 20.625 19.338 21.608V22.7502H7.80273V21.608C7.80273 20.6216 8.47449 19.7369 9.42853 19.4742Z",
    fill: "#A54F7B",
    stroke: "#7F0442",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.3691 13.8526C16.3691 15.6702 15.0423 17.0229 13.5634 17.0229C12.0838 17.0229 10.7578 15.6762 10.7578 13.8526V13.1981C10.7578 11.3805 12.0846 10.0278 13.5634 10.0278C15.0423 10.0278 16.3691 11.3805 16.3691 13.1981V13.8526Z",
    fill: "#A54F7B",
    stroke: "#7F0442",
    strokeWidth: "1.5"
  }));
};

LineManagers.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
LineManagers.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = LineManagers;
exports.default = _default;